import api from '../../services/api';

const urlBase = '/financeiro';

export default {
	listar: () => api.get(urlBase),

	listarContas: () => api.get(`${urlBase}/contas`),

	criarConta: (data) => api.post(`${urlBase}/contas`, data),

	atualizarConta: (contaId, data) => api.put(`${urlBase}/contas/${contaId}`, data),

	excluirConta: (contaId) => api.delete(`${urlBase}/contas/${contaId}`),

	criar: (data) => api.post(urlBase, data),

	criarEmLote: (lancamentos) => api.post(urlBase, { lancamentos }),

	atualizar: (lancamentoId, data) => api.put(`${urlBase}/${lancamentoId}`, data),

	darBaixa: (lancamentoId, data) => api.put(`${urlBase}/${lancamentoId}/baixa`, data),

	excluir: (lancamentoId) => api.delete(`${urlBase}/${lancamentoId}`),
};